var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[_vm.selected ? (_vm.hasError ? 'item_error' : 'item_on') : '']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }